<template>
  <div>
    <div class="container" style="margin-bottom: 50px;">
      <section class="section">
        <h3 class="title is-4">Welcome</h3>
        <hr>
        <p>Thank you for registering, you are now logged in.
        </p>
        </br>
        <div class="box">
          <div class="content">
            <p>
              Read our Getting Started documentation for information about managing associations and direct link requests.
            </p>
            <router-link to="/documentation" class="button is-link is-outlined">Getting Started</router-link>
          </div>
        </div>

        <div class="box">
          <div class="content">
            <p>
              Start managing associations and generating certificates.
            </p>
            <router-link to="/associations" class="button is-link is-outlined">Manage Associations</router-link>
          </div>
        </div>

      </section>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import Footer from '@/Footer'
  export default {
    name: 'Welcome',
    created: function () {
      window.document.title = 'Welcome | Property Insurance Certificates'
    },
    components: {
      Footer
    }
  }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Welcome.vue?7d46e05c